import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetOpenItemsQuery,
  useSubmitClarificationMutation,
} from "store/apis/openItem";
import { closeCalrifyModal } from "store/slices/openItem";
import { RootState } from "store/store";
import { pluralize } from "utils/pluralize";
import { OpenItemTable } from "./OpenItemTable";
import { actionItemsApi } from "store/apis/actionItems";

export const ClarifyModal = () => {
  const dispatch = useDispatch();
  const { alertToast, successToast } = useToast();
  const { isCustomer } = useRoleBasedView();
  const { activeChannelGroupId: groupId } = useSelector(
    (state: RootState) => state.reviewAndBalancePayment
  );
  const [submitClarification, { isLoading: isSubmitting }] =
    useSubmitClarificationMutation();
  const { csvId, messageId, show, status } = useSelector(
    (state: RootState) => state.openItem.calrifyModal
  );

  const { data: uploadedCSV } = useGetOpenItemsQuery(
    { csvId, groupId },
    { skip: !groupId || !csvId || !show }
  );

  const totalCount = uploadedCSV?.open_items?.length ?? 0;

  const onClose = () => {
    dispatch(closeCalrifyModal());
  };

  const onSubmit = async () => {
    try {
      await submitClarification({ groupId, messageId, csvId }).unwrap();
      successToast({ message: "Submitted" });
      setTimeout(() => {
        dispatch(
          actionItemsApi.util.invalidateTags([{ type: "ALL_ACTION_ITEMS" }])
        );
      }, 1000);
      onClose();
    } catch (error: any) {
      alertToast({ message: error?.data?.error?.message });
    }
  };

  return (
    <Modal.Root open={show} onOpenChange={onClose}>
      <Modal.Content size="xxl">
        <Modal.Header>
          <div>
            <Modal.Title>
              {status === "REQUESTED" ? "Clarify open items" : "Open items"}
            </Modal.Title>
            {totalCount > 0 && (
              <Modal.Subtitle>
                {pluralize(totalCount, "item", "items")}
              </Modal.Subtitle>
            )}
          </div>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <OpenItemTable csvId={csvId} />
        </Modal.Body>
        {status === "REQUESTED" && isCustomer && (
          <Modal.FooterButtonGroup>
            <Button
              customType="secondary"
              type="button"
              onClick={onClose}
              className="t-hidden sm:t-flex"
            >
              Close
            </Button>
            <Button
              customType="primary"
              type="submit"
              onClick={onSubmit}
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Submit
            </Button>
          </Modal.FooterButtonGroup>
        )}
      </Modal.Content>
    </Modal.Root>
  );
};
